import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { onUpdateAvailable, applyPwaUpdate } from '../pwaUpdate';

export default function UpdateAvailableToast() {
  const [visible, setVisible] = useState(false);

  useEffect(() => onUpdateAvailable(() => setVisible(true)), []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 14px',
        background: 'rgba(20, 24, 32, 0.95)',
        color: '#fff',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: 12,
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(8px)',
        fontSize: 13,
        maxWidth: 'calc(100vw - 32px)',
      }}
    >
      <span style={{ fontWeight: 600 }}>새 버전이 있습니다.</span>
      <button
        type="button"
        onClick={applyPwaUpdate}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '6px 12px',
          borderRadius: 8,
          background: 'linear-gradient(135deg, #6366F1, #8B5CF6)',
          color: '#fff',
          border: 'none',
          fontSize: 12,
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        <FontAwesomeIcon icon={faRotateRight} />
        새로고침
      </button>
      <button
        type="button"
        onClick={() => setVisible(false)}
        aria-label="닫기"
        style={{
          padding: 4,
          background: 'transparent',
          border: 'none',
          color: 'rgba(255, 255, 255, 0.6)',
          cursor: 'pointer',
          lineHeight: 1,
        }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
}
